import { render, staticRenderFns } from "./PlayerContestRewards.vue?vue&type=template&id=58ad8e8a&scoped=true&"
import script from "./PlayerContestRewards.vue?vue&type=script&lang=js&"
export * from "./PlayerContestRewards.vue?vue&type=script&lang=js&"
import style0 from "./PlayerContestRewards.vue?vue&type=style&index=0&id=58ad8e8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad8e8a",
  null
  
)

export default component.exports